<template>
  <div class="vcv-tiptap-menu-item" :class="{ disabled }">
    <div
      v-if="icon === 'file-upload-line'"
      v-tooltip.top-center="$tr('editor.uploadFile')"
      class="vcv-tiptap-menu-item__fileupload"
    >
      <input ref="file" class="vcv-tiptap-menu-item__fileupload-input" type="file" @change="uploadFile('file')" />

      <button class="vcv-tiptap-menu-item__item" :title="title">
        <i :class="`icon-${icon}`"></i>
      </button>
    </div>

    <div
      v-else-if="icon === 'image-line'"
      v-tooltip.top-center="$tr('editor.uploadImageTooltip')"
      class="vcv-tiptap-menu-item__fileupload"
      :class="{ disabled }"
    >
      <input ref="file" class="vcv-tiptap-menu-item__fileupload-input" type="file" @change="uploadFile('image')" />

      <button class="vcv-tiptap-menu-item__item" :title="title">
        <i :class="`icon-${icon}`"></i>
      </button>
    </div>

    <div
      v-else-if="icon === 'input-method-line'"
      v-tooltip.top-center="$tr('variables.add-variable')"
      class="vcv-tiptap-menu-item__variables"
      :class="{ disabled }"
    >
      <vcv-tiptap-variables-menu :question-variables="variables" @click="$emit('add-variable', $event)" />
    </div>

    <button
      v-else
      v-tooltip.top-center="title"
      class="vcv-tiptap-menu-item__item"
      :class="{ 'is-active': isActive ? isActive() : null, disabled }"
      @click="action"
    >
      <i :class="`icon-${icon}`"></i>
    </button>
  </div>
</template>

<script>
import VcvTiptapVariablesMenu from '@/components/VcvTiptap/VcvTiptapVariablesMenu.vue';

export default {
  components: {
    VcvTiptapVariablesMenu
  },

  props: {
    icon: {
      type: String,
      required: true
    },

    title: {
      type: String,
      required: true
    },

    action: {
      type: Function,
      default: () => 1
    },

    isActive: {
      type: Function,
      default: null
    },

    disabled: {
      type: Boolean,
      default: false
    },

    variables: {
      type: [Array],
      default: () => []
    }
  },

  methods: {
    uploadFile(fileType) {
      const files = this.$refs.file.files;
      const file = files[0];

      if (!file) {
        return;
      }
      // const size = file.size ? file.size / 1024 / 1024 : 0;

      if (file) {
        this.$store
          .dispatch('services/saveCompanyImage', {
            imageUrl: file
          })
          .then(data => {
            const href = data.url;

            this.$emit('set-link', { href, fileType });

            this.$refs.file.value = '';
          })
          .catch(err => {
            if (err && err.response && err.response.data && err.response.data.meta) {
              this.$noty.error(err.response.data.meta.error.message);
            }
            this.$refs.file.value = '';
          });
      } else {
        this.file = null;
      }
    }
  }
};
</script>

<style lang="scss">
.variables-menu__menu {
  right: initial !important;
}

.vcv-tiptap-menu-item {
  &__item {
    width: 1.6rem;
    height: 1.6rem;
    color: $grey-darker;
    border: none;
    background-color: transparent;
    border-radius: 4px;
    padding: 5px;
    margin-right: 3px;
    transition: all 0.3s;

    svg {
      width: 100%;
      height: 100%;
      fill: currentColor;
    }

    &.is-active,
    &:hover {
      color: #fff;
      background-color: $green;
      transition: all 0.3s;
    }

    &.disabled {
      opacity: 0.5;
      pointer-events: none;
      height: auto !important;
    }

    &.is-disabled {
      height: auto !important;
    }
  }

  &__fileupload {
    position: relative;
    width: 1.6rem;
    height: 1.6rem;
    overflow: hidden;
    margin-right: 0.25rem;
    cursor: pointer;

    &:hover .vcv-tiptap-menu-item__item {
      color: #fff;
      background-color: $green;
      transition: all 0.3s;
    }
  }

  &__fileupload-input {
    position: absolute;
    width: 100%;
    opacity: 0;
    height: 100% !important;
    cursor: pointer;
  }

  ::-webkit-file-upload-button {
    opacity: 0;
    cursor: pointer;
  }

  &__variables {
    margin-right: 4px;
  }
}
</style>
